import styled from '@emotion/styled/macro';
import { Variables } from '@enter/core';

interface IToggleProps {
    enabled: boolean;
}

export const Toggle = styled.div<IToggleProps>`
    --toggle-offset: ${(props: IToggleProps): string => (props.enabled ? '18px' : '0')};
    --toggle-bgcolor: ${(props: IToggleProps): string =>
        props.enabled ? Variables.Colors.b300 : Variables.Colors.n30};

    display: flex;
    height: 32px;
    width: 48px;
    border-radius: 32px;

    align-items: center;
    background-color: var(--toggle-bgcolor);
    cursor: pointer;
`;

export const Knob = styled.div`
    height: 30px;
    width: 30px;
    border-radius: 30px;
    margin-left: var(--toggle-offset);
    box-shadow: 0 0 0 1px var(--toggle-bgcolor);
    background-color: ${Variables.Colors.white};

    transition: all 0.2s ease-in-out;
`;
